/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Config setter and getter (@accedo/xdk-config) 4.2.3
* 
*******************************************************************************/
const XDK_PRIVATE_KEY_PREFIX="__xdk-",KEY={DEVICE_DEFAULT_CONFIG_KEY:"__xdk-default-device-details",DEVICE_PACKAGES_INFO_KEY:"device-details",NETWORK:"network",PLAYERS:"players",STORAGES:"storages",EXTENSIONS:"extensions",MOUSE:"mouse",MEDIA:"media",KEYMAPPING:"keymapping"};export{KEY};